import { Avatar } from "@nextui-org/avatar";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import ExpandableText from "@/app/components/ExpandibleText";
import { AssociateProfiles } from "@/app/author/(components)/AssociateButton";
import CopernicusBadge from "@/app/author/(components)/CopernicusBadge";

export function AuthorHeader({ info, isVerified, authorId, isCopernicus }) {
  return (
    <div className="flex flex-col justify-center items-center ">
      <div className="mb-5">
        <Avatar
          src={info.img || "/autoricon.png"}
          className="w-40 h-40 text-large"
          name={`Foto de ${info.label}`}
        />
      </div>
      <h1 className="text-5xl flex justify-center items-center gap-2 font-semibold">
        <span className="text-blue-800">{info.label}</span>
        {isVerified && (
          <RiVerifiedBadgeFill className="text-3xl text-cyan-400" />
        )}
      </h1>

      {info.bio && <ExpandableText text={info.bio} />}
      {isCopernicus && <CopernicusBadge size={75} />}

      <AssociateProfiles
        label={info.label}
        authorId={authorId}
        isVerified={isVerified}
      />
    </div>
  );
}
